/**
 * Final-evaluation intro screen.
 */
import { TextField } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { useAsterController } from "context";
import { VButton } from "form";

/**
 * Collects acknowledgement and starts the final exam.
 *
 * @param {{ onContinue?: Function }} props
 */
const FinalFirst = (props) => {
  const { onContinueClick } = props;

  const { t } = useTranslation("common");

  const [controller] = useAsterController();
  const { user } = controller;

  const [fields, setFields] = useState({ firstName: "", lastName: "" });
  const [isWrong, setIsWrong] = useState(false);

  /**
   * Updates the acknowledgement checkbox.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} e Change event.
   * @returns {void}
   */
  const onChange = (e) => {
    setIsWrong(false);
    setFields({ ...fields, [e.target.name]: e.target.value });
  };

  /**
   * Continues when the learner has acknowledged the exam rules.
   *
   * @returns {void}
   */
  const onSubmit = () => {
    if ((!user.first_name || user.first_name?.toLowerCase()?.trim() === fields.firstName?.toLowerCase()?.trim()) && (!user.last_name || user.last_name?.toLowerCase()?.trim() === fields.lastName?.toLowerCase()?.trim())) {
      onContinueClick();
    } else {
      setIsWrong(true);
    }
  };

  return (
    <>
      <div className="w-full">
        <div className="flex items-center flex-col shadow mt-5 p-4">
          <div className="text-base text-dark">
            {t("Before starting, please confirm the information below which will appear on your certificate of achievement.")}&nbsp;
            {t("Please type:")}&nbsp;&quot;<b>{user.first_name || ""}</b>&quot;, &quot;<b>{user.last_name || ""}</b>&quot;
          </div>
          <div className="row mt-3">
            <div className="col-md-6">
              <div>
                <div className="text-xs fw-500 lh-16 mb-3 text-uppercase mt-3">
                  {t("First Name")}&nbsp;<span className="text-danger">*</span>
                </div>
                <TextField type="text" name="firstName" value={fields.firstName} onChange={onChange} placeholder={user.first_name || ""} size="small" />
              </div>
            </div>
            <div className="col-md-6">
              <div className="text-xs fw-500 lh-16 mb-3 text-uppercase mt-3">
                {t("Last Name")}&nbsp;<span className="text-danger">*</span>
              </div>
              <TextField type="text" name="lastName" value={fields.lastName} onChange={onChange} placeholder={user.last_name || ""} size="small" />
            </div>
          </div>
          {isWrong && <div className="text-sm text-danger mt-3">{t("First name or last name is incorrect. Please check again!")}</div>}
          <div className="mt-3">
            <VButton onClick={onSubmit} variant="contained">
              {t("Submit")}
            </VButton>
          </div>
        </div>
      </div>
    </>
  );
};

export default FinalFirst;
